
import { Component, Prop, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";

@Component
export default class TotalTagsScanned extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly tags!: Models.Tag[];

  get total(): number {
    return this.tags ? this.tags.length : 0;
  }
}
